import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

// Horizon 4.1.1 owns all cart requests, quantities, properties and cart-drawer updates.
export class CultivatorStickyATC extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }
  updatedCallback() { super.updatedCallback(); this.deactivate(); this.initialize(); }
  initialize() {
    this.controller?.abort(); this.controller = new AbortController();
    this.timers = new Set(); this.generation = 0; this.pending = false; this.changing = false; this.uncertain = false;
    try { this.config = JSON.parse(this.querySelector('[data-clt-atc-config]').textContent); } catch { return; }
    this.strings = this.config.strings; this.variant = this.config.variant;
    const signal = this.controller.signal;
    customElements.whenDefined('product-form-component').then(() => {
      if (signal.aborted || !this.isConnected || document.querySelector('clt-sticky-atc[data-ready="true"]')) return;
      this.setup();
    });
  }
  getProductForm() {
    return [...document.querySelectorAll('product-form-component')].find(el => el.dataset.productId === this.config.productId && !el.closest('product-card,quick-add-dialog,dialog'));
  }
  getNativeButton() { return this.getProductForm()?.querySelector('[ref="addToCartButton"]'); }
  later(fn, delay) { const id = setTimeout(() => { this.timers.delete(id); if (!this.controller.signal.aborted) fn(); },delay); this.timers.add(id); return id; }
  setup() {
    const native = this.getNativeButton(); this.formComponent = this.getProductForm();
    if (!native || !this.formComponent?.querySelector('form')) return;
    this.mainSection = this.formComponent.closest('.shopify-section'); if (!this.mainSection) return;
    const {signal} = this.controller;
    this.button = this.querySelector('[data-clt-add]'); this.status = this.querySelector('[data-clt-status]');
    this.addEventListener('click',this.handleClick,{signal});
    document.addEventListener(StandardEvents.productSelect,this.selectVariant,{signal});
    document.addEventListener(StandardEvents.cartLinesUpdate,this.onCart,{signal});
    document.addEventListener(StandardEvents.cartError,this.onCartError,{signal});
    this.mainSection.addEventListener('change',this.refresh,{signal});
    this.media = matchMedia('(max-width:749px)'); this.media.addEventListener('change',this.updateVisibility,{signal});
    this.observer = new IntersectionObserver(entries => {
      this.passed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; this.updateVisibility();
    });
    this.observer.observe(this.formComponent.closest('.buy-buttons-block') || this.formComponent);
    this.mutations = new MutationObserver(() => this.refresh());
    this.mutations.observe(this.mainSection,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value','checked']});
    this.resize = new ResizeObserver(() => this.setHeight()); this.resize.observe(this.querySelector('[data-clt-bar]'));
    this.cover = new MutationObserver(() => {
      const covered = !!document.querySelector('dialog[open],theme-drawer[open]');
      this.dataset.covered = String(covered);
    }); this.cover.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});
    document.body.classList.add('clt-atc-active');
    this.dataset.ready = 'true'; this.hidden = false;
    this.refresh(); this.updateVisibility();
  }
  setHeight() {
    const height = this.querySelector('[data-clt-bar]')?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--clt-sticky-atc-height',`${Math.ceil(height)}px`);
  }
  updateVisibility = () => {
    this.dataset.visible = String(this.media.matches || this.config.desktop && !!this.passed);
    this.setHeight();
  };
  refresh = () => {
    if (!this.button || !this.isConnected) return;
    const native = this.getNativeButton();
    const owner = native?.closest('add-to-cart-component');
    if (owner) owner.classList.add('clt-atc-native');
    const input = this.getProductForm()?.querySelector('input[name="id"]');
    const valid = native && input?.value && !native.disabled;
    this.button.disabled = this.pending || this.changing || this.uncertain || !valid;
    this.button.textContent = this.pending ? this.strings.adding : this.changing ? this.strings.checking : !input?.value ? this.strings.unavailable : !valid ? (this.variant?.available === false ? this.strings.sold_out : this.strings.unavailable) : this.strings.add;
    const quantity = Number(this.getProductForm()?.querySelector('[name="quantity"]')?.value || 1);
    if (valid && !this.pending && !this.changing && quantity > 1) this.button.textContent += ` · ${quantity}`;
    this.button.setAttribute('aria-busy',String(this.pending || this.changing));
    const picker = this.mainSection?.querySelector('variant-picker');
    const selected = [...(picker?.querySelectorAll('input:checked,select option:checked') || [])].map(el => el.value).filter(Boolean);
    this.querySelector('[data-clt-colour-label]').textContent = selected.join(' / ') || this.variant?.title || this.config.title;
    this.querySelector('[data-clt-change]').hidden = !picker;
    this.querySelector('[data-clt-single]').hidden = !!picker;
    const priceOwner = this.mainSection?.querySelector('product-price');
    const price = priceOwner?.querySelector('.price')?.textContent?.trim();
    const compare = priceOwner?.querySelector('.compare-at-price')?.textContent?.trim();
    if (price) this.querySelector('[data-clt-price]').textContent = price;
    const compareEl = this.querySelector('[data-clt-compare]'); compareEl.textContent = compare || ''; compareEl.hidden = !compare;
  };
  handleClick = event => {
    if (event.target.closest('[data-clt-change]')) {
      const picker = this.mainSection.querySelector('variant-picker');
      if (picker) {
        picker.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
        (picker.querySelector('input:checked,select') || picker.querySelector('input'))?.focus({preventScroll:true});
      }
      return;
    }
    if (!event.target.closest('[data-clt-add]') || this.pending || this.changing || this.uncertain) return;
    const native = this.getNativeButton(); const form = this.getProductForm()?.querySelector('form');
    if (!native || native.disabled || !form) { this.refresh(); return; }
    if (!form.reportValidity()) { form.scrollIntoView({block:'center'}); return; }
    this.clearStatus(); this.cartStarted = false;
    native.dataset.puppet = 'true'; native.click();
    // The native handler synchronously emits the event, unless validation blocked submission.
    if (!this.cartStarted) {
      native.dataset.puppet = 'false';
      const error = this.getProductForm()?.querySelector('[ref="addToCartTextError"]');
      this.showError(error && !error.classList.contains('hidden') ? error.textContent.trim() : this.strings.error);
      this.refresh();
    }
  };
  selectVariant = async event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card,quick-add-dialog,dialog') || !this.mainSection.contains(event.target)) return;
    const generation = ++this.generation;
    this.changing = true; if (!this.uncertain) this.clearStatus(); this.refresh();
    try {
      const {detail} = await event.promise;
      if (generation !== this.generation || this.controller.signal.aborted || !this.isConnected) return;
      if (detail?.newProduct && String(detail.newProduct.id) !== this.config.productId) { this.deactivate(); return; }
      if (detail?.productId && String(detail.productId) !== this.config.productId) return;
      this.variant = detail?.resource || null;
      // Native product-form and product-price listeners settle before the document listener.
      await Promise.resolve();
      this.changing = false; this.refresh();
    } catch (error) {
      if (generation !== this.generation || this.controller.signal.aborted) return;
      // Keep the old colour from being purchased after an unsuccessful selection request.
      this.changing = true; this.showError(this.strings.review); this.refresh();
    }
  };
  onCart = async event => {
    if (!(event.target instanceof Element) || event.target !== this.getProductForm() || event.action !== 'add') return;
    this.cartStarted = true; this.pending = true; this.clearStatus(); this.refresh();
    const request = this.request = (this.request || 0) + 1;
    const timeout = this.later(() => {
      if (this.pending && this.request === request) { this.uncertain = true; this.pending = false; this.showError(this.strings.network_error,true); this.refresh(); }
    },20000);
    try {
      const {detail} = await event.promise;
      if (this.controller.signal.aborted || request !== this.request) return;
      clearTimeout(timeout); this.timers.delete(timeout);
      this.pending = false; this.uncertain = false;
      if (detail?.didError) { if (!this.status.textContent) this.showError(this.strings.error); }
      else {
        this.clearStatus(); this.status.textContent = this.strings.added; this.status.dataset.error = 'false';
        this.later(() => { if (this.status.dataset.error !== 'true') this.clearStatus(); },1500);
      }
    } catch {
      if (this.controller.signal.aborted || request !== this.request) return;
      clearTimeout(timeout); this.timers.delete(timeout);
      this.pending = false; this.uncertain = true; this.showError(this.strings.network_error,true);
    } finally {
      if (!this.controller.signal.aborted) { const native = this.getNativeButton(); if (native) native.dataset.puppet = 'false'; this.refresh(); }
    }
  };
  onCartError = event => {
    if (event.target !== this.getProductForm()) return;
    this.showError(event.detail?.description || event.error || this.strings.error);
  };
  showError(message, recovery = false) { this.status.textContent = message; this.status.dataset.error = 'true'; this.querySelector('[data-clt-cart]').hidden = !recovery; }
  clearStatus() { this.status.textContent = ''; this.status.dataset.error = 'false'; this.querySelector('[data-clt-cart]').hidden = true; }
  deactivate() {
    this.dataset.ready = 'false'; this.dataset.visible = 'false'; this.hidden = true;
    this.controller?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.mutations?.disconnect(); this.cover?.disconnect();
    this.timers?.forEach(clearTimeout); this.timers?.clear();
    this.mainSection?.querySelectorAll('.clt-atc-native').forEach(el => el.classList.remove('clt-atc-native'));
    if (!document.querySelector('clt-sticky-atc[data-ready="true"]')) {
      document.body.classList.remove('clt-atc-active'); document.documentElement.style.removeProperty('--clt-sticky-atc-height');
    }
  }
  disconnectedCallback() { super.disconnectedCallback(); this.deactivate(); }
}
if (!customElements.get('clt-sticky-atc')) customElements.define('clt-sticky-atc',CultivatorStickyATC);
